var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.199,
    height: 44.425,
    viewBox: "0 0 39.199 44.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-car-door-4075591",
    transform: "translate(-11.656 -6.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8429",
    "data-name": "Group 8429",
    transform: "translate(11.656 6.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9613",
    "data-name": "Path 9613",
    d: "M49.859,51.025H26.726a4.179,4.179,0,0,1-3.992-2.866,20.531,20.531,0,0,0-8.394-10.9A3.944,3.944,0,0,1,12.549,34.9a21.49,21.49,0,0,1,0-12.232l.051-.1a60.742,60.742,0,0,1,8.291-12.8A3.093,3.093,0,0,1,22.529,8.75c2.508-.614,9.52-2.047,20.933-2.15a3.128,3.128,0,0,1,3.071,2.457A122.42,122.42,0,0,1,48.58,22.005a3.52,3.52,0,0,0,.614,1.689c.717.921,1.126,2.968,1.28,6.244.051.768,1.075,16.89-.461,20.626ZM13.982,23.183a19.716,19.716,0,0,0,0,11.311,2.544,2.544,0,0,0,1.126,1.484A22.029,22.029,0,0,1,24.167,47.7a2.642,2.642,0,0,0,2.559,1.843h22.11c.972-3.531.512-15.149.2-19.5h0c-.2-3.992-.768-5.118-.972-5.425a4.934,4.934,0,0,1-.921-2.457A106.511,106.511,0,0,0,45.1,9.364a1.549,1.549,0,0,0-1.587-1.228c-11.26.154-18.169,1.535-20.626,2.15a2.174,2.174,0,0,0-.87.512A62.28,62.28,0,0,0,13.982,23.183Zm9.161,8.7H20.379a2.2,2.2,0,1,1,0-4.4h2.764a2.2,2.2,0,1,1,0,4.4Zm-2.764-2.866a.717.717,0,1,0,0,1.433h2.764a.717.717,0,1,0,0-1.433ZM42.8,25.844h-.051l-21.086-.768a2.023,2.023,0,0,1-1.945-2V20.214a6.4,6.4,0,0,1,.921-3.327L23.5,12.179a2.012,2.012,0,0,1,1.28-.921A50.887,50.887,0,0,1,41.619,9.927a2.012,2.012,0,0,1,1.791,1.74l1.382,11.874a2,2,0,0,1-.512,1.587A1.813,1.813,0,0,1,42.8,25.844Zm-4.35-14.586a63.6,63.6,0,0,0-13.358,1.535.47.47,0,0,0-.307.2l-2.866,4.709a4.9,4.9,0,0,0-.717,2.508V23.08a.5.5,0,0,0,.461.512l21.086.768a.763.763,0,0,0,.409-.154.618.618,0,0,0,.154-.409L41.875,11.923a.543.543,0,0,0-.461-.461A18.861,18.861,0,0,0,38.446,11.257Z",
    transform: "translate(-11.656 -6.6)",
    fill: "#253845"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarDoorIcon);
export default __webpack_public_path__ + "static/media/car-door-icon.20f9c03bda9481603cf9b134de9211fd.svg";
export { ForwardRef as ReactComponent };